import z from "zod";
import { agentTypeSchema } from "../../../config/agent-registry";
import {
  createAgentConnection,
  updateAgentConnection,
  agentConnection,
} from "./agent-connection-validators";

const createAgentSchema = z.object({
  name: z.string().min(1, "Required"),
  type: agentTypeSchema,
  description: z.string().min(1, "Required"),
  instructions: z.string().min(1, "Required"),
  enabled: z.boolean().default(false),
  chatProviderId: z.string().uuid(),
});

const updateAgentSchema = z.object({
  name: z.string().min(1).optional(),
  type: agentTypeSchema.optional(),
  description: z.string().min(1).optional(),
  instructions: z.string().min(1).optional(),
  enabled: z.boolean().optional(),
  chatProviderId: z.string().uuid().optional(),
});

const findAgentsFiltersSchema = z.object({
  page: z.coerce.number().default(1),
  per_page: z.coerce.number().default(10),
  filter: z
    .object({
      search: z.string().optional(),
      enabled: z.boolean().optional(),
      type: agentTypeSchema.optional(),
      chatProviderId: z.string().uuid().optional(),
    })
    .optional(),
});

const agentSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  type: agentTypeSchema,
  description: z.string(),
  instructions: z.string(),
  enabled: z.boolean(),
  chatProviderId: z.string().uuid().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

const findAgentsSchema = z.object({
  data: z.array(agentSchema),
  count: z.number(),
});

export const createAgent = createAgentSchema;
export const updateAgent = updateAgentSchema;
export const findAgents = findAgentsSchema;
export const findAgent = agentSchema;

// Public agent type metadata (safe for UI consumption - no sensitive data)
export const agentTypeMetadataPublic = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  category: z.string(),
  type: z.string(),
  icon: z.string(),
  status: z.string().nullable(),
  version: z.string(),
  ribbon: z.string().nullable(),
  href: z.string(),
});

// Array of public agent type metadata
export const agentTypesPublic = z.array(agentTypeMetadataPublic);

// Categories array
export const agentTypeCategories = z.array(z.string());

// Agent type keys array
export const agentTypeKeysArray = z.array(z.string());

// Configuration template for forms (contains placeholders but not actual secrets)
export const agentConfigTemplate = z.object({
  type: z.string(),
  name: z.string(),
  description: z.string(),
  template: z.record(z.string(), z.string()), // placeholder values only, no actual secrets
});

export const agentValidators = {
  createAgentSchema,
  updateAgentSchema,
  findAgentsFiltersSchema,
  agentSchema,
  findAgentsSchema,
  // Connection validators
  createAgentConnection,
  updateAgentConnection,
  agentConnection,
  // Public agent type validators
  agentTypeMetadataPublic,
  agentTypesPublic,
  agentTypeCategories,
  agentTypeKeysArray,
  agentConfigTemplate,
};
